var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "empty" }, [
      _c("div", { staticClass: "empty__message" }, [
        _c("i", { staticClass: "uk-icon-check" }),
        _vm._v(" "),
        _c("span", [_vm._v("Сообщения эмитента не найдены.")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }